import { useState, useEffect } from "react"
import "./ViewSubscriptionReceiptSection.scss"
import BreadCrumbComponent from "../../Misc/BreadCrumb/BreadCrumbComponent"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { routeList } from "../../../../utils/routeList"
import RightPanelPaymentSection from "../../Payment/RightPanelPayment/RightPanelPaymentSection"
import _ from "lodash"
import { fetchSubscribedReceipt, fetchSubscribedReceiptClear, setPreSubscriptionReceiptDataClear } from "../../../../redux/checkout/actions"
import CONFIG from "../../../../utils/config"
import API_LIST from "../../../../utils/apiList"
import { SessionKeys } from "../../../../utils/AppUtils"
import moment from "moment"
import ShimmerScreen from "../../../Layouts/ShimmerScreen"

const ViewSubscriptionReceiptSection = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const preData = useSelector(state => state.checkout.preSubscriptionReceiptInfo)
    const subscriptionReceipt = useSelector(state => state.checkout.subscriptionReceipt)

    const [isLoading, setIsLoading] = useState(true)
    const [breadCrumbData, setBreadCrumbData] = useState([
        { name: 'Home', active: false, link: routeList.HOME_PAGE, isLoading: false },
        { name: 'Subscription', active: false, link: routeList.SUBSCRIPTION_PAGE, isLoading: false },
        { name: 'Receipt', active: true, link: "", isLoading: false },
    ])
    const [billingData, setBillingData] = useState({
        email: "", brokerageName: "", brokerageEmail: "",
        firstName: "", lastName: "",
        phoneNumber: "", addressLine1: "", addressLine2: "",
        city: "", state: "", country: "", postalCode: ""
    })
    const [membershipCardInfo, setMembershipCardInfo] = useState({
        isLoading: true,
        id: "",
        title: "",
        logoAltText: "",
        logoURL: "",
        bannerURL: "",
        tagsArray: [],
        price: ""
    })
    const [paymentDetail, setPaymentDetails] = useState({
        orderId: "", renewalDate: "", purchaseDate: ""
    })
    const [paymentIntentInfo, setPaymentIntentInfo] = useState({
        isLoading: false, taxes: "", total: ""
    })
    const [renewalData, setRenewalData] = useState([])

    useEffect(() => {
        setTimeout(() => {
            if (_.isEmpty(preData)) navigate(routeList.SUBSCRIPTION_PAGE)
        }, 2000)
    }, [dispatch])

    useEffect(() => {
        if (!_.isEmpty(preData)) {
            dispatch(fetchSubscribedReceipt({
                method: "POST",
                URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_RECEIPT}`,
                payload: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    subscription_id: preData.subscriptionId
                },
                isJSON: true
            }))
            dispatch(setPreSubscriptionReceiptDataClear({}))
        }
    }, [preData])

    useEffect(() => {
        if (!_.isEmpty(subscriptionReceipt)) {
            if (subscriptionReceipt.status === 'success') {
                const response = subscriptionReceipt.payload.data;
                if (!_.isEmpty(response)) {
                    let tagsArray = [];
                    let logoURL = ""
                    let logoAltText = ""
                    if (response.provider_info) {
                        tagsArray.push(`Xsel ${response.title} subscription`)
                        logoURL = response.provider_info.provider_img;
                        logoAltText = response.provider_info.provider.substring(0, 1)
                    }
                    setMembershipCardInfo({
                        isLoading: false,
                        id: "",
                        title: `Xsel ${response.title} subscription plan - Renews 
                        ${response.billing_type === 'annually' ? 'yearly' : 'monthly'}`,
                        price: _.toNumber(response.billing_amount),
                        bannerURL: response.subscription_img ? response.subscription_img : "",
                        logoURL,
                        logoAltText,
                        tagsArray
                    })

                    setBillingData({
                        email: response.billing_details.contactEmail,
                        brokerageName: response.billing_details.brokerageName ? response.billing_details.brokerageName : "",
                        brokerageEmail: response.billing_details.brokerageEmail ? response.billing_details.brokerageEmail : "",
                        firstName: response.billing_details.firstName,
                        lastName: response.billing_details.lastName,
                        phoneNumber: response.billing_details.phoneNumber,
                        addressLine1: response.billing_details.addressLine1,
                        addressLine2: response.billing_details.addressLine2,
                        city: response.billing_details.city,
                        state: response.billing_details.state,
                        country: response.billing_details.country,
                        postalCode: response.billing_details.postalCode
                    })
                    setPaymentDetails({
                        orderId: 'OR-' + response.order_number,
                        renewalDate: response.next_renewal_date ? 
                        moment.unix(response.next_renewal_date).tz('America/New_York').format('MMM DD, YYYY') : "",
                        purchaseDate: moment.unix(response.purchased_on).tz('America/New_York').format('MMM DD, YYYY')
                    })
                    setPaymentIntentInfo({
                        isLoading: false,
                        taxes: response.taxes,
                        total: response.total
                    })
                    setRenewalData(response.renewal_details)
                } else {
                    navigate(routeList.SUBSCRIPTION_PAGE)
                }
            } else {
                navigate(routeList.SUBSCRIPTION_PAGE)
            }
            setIsLoading(false)
            dispatch(fetchSubscribedReceiptClear())
        }
    }, [subscriptionReceipt])

    const renderLeftPanel = () => {
        return (
            <div className="payment-info-details">
                <div className="user-payment-info">
                    <div className="usermail-info">{
                        !isLoading ? billingData.email :
                        <ShimmerScreen 
                            case="rect"
                            width="20rem"
                            height="1rem"
                        />
                        }
                    </div>
                    <div className="usermail-info-brokarage">{
                        !isLoading ?
                        billingData.brokerageEmail ? billingData.brokerageEmail : billingData.brokerageName
                        :
                        <ShimmerScreen 
                            case="rect"
                            width="15rem"
                            height="1rem"
                        />
                    }</div>
                </div>
                <div className="user-billing-info">
                    <div className="billing-title">Billing details</div>
                    {!isLoading ?
                    <div className="billing-details">
                        <div className="user-name-billing">{billingData.firstName} {billingData.lastName}</div>
                        <div className="user-address-billing">
                            {billingData.addressLine1} {billingData.addressLine2 ? ', ' + billingData.addressLine2 : ''},
                            {billingData.city}, {billingData.state} {billingData.country} {billingData.postalCode}
                        </div>
                        <div className="user-country-billing">Canada</div>
                        <div className="user-phone-billing">{billingData.phoneNumber}</div>
                    </div>
                    :
                    <div className="billing-details">
                        <ShimmerScreen 
                            case="rect"
                            width="20rem"
                            height="1rem"
                        />
                        <ShimmerScreen 
                            case="rect"
                            width="20rem"
                            height="1rem"
                        />
                        <ShimmerScreen 
                            case="rect"
                            width="10rem"
                            height="1rem"
                        />
                        <ShimmerScreen 
                            case="rect"
                            width="10rem"
                            height="1rem"
                        />
                    </div>
                    }
                </div>
                <div className="user-order-info">
                    <div className="order-detail-title">Order details</div>
                    <div className="order-billing-details">
                        <div className="order-info-ids">
                            <span className="order-billing-id">
                                Order ID: {!isLoading ? paymentDetail.orderId : 
                                <ShimmerScreen 
                                case="rect"
                                width="5rem"
                                height="1rem"
                                />}
                            </span>
                            <span className="order-transaction-id">
                                Next renewal date: {!isLoading ?
                                paymentDetail.renewalDate :
                                <ShimmerScreen 
                                    case="rect"
                                    width="5rem"
                                    height="1rem"
                                />
                                }
                            </span>
                        </div>
                        <div className="order-purchase-id">
                            Date of purchase: {!isLoading ? paymentDetail.purchaseDate :
                                <ShimmerScreen 
                                    case="rect"
                                    width="5rem"
                                    height="1rem"
                                />
                            }
                        </div>
                    </div>
                </div>
                {isLoading ? "" : 
                <div className="user-order-info">
                    <div className="order-detail-title">Renewal details</div>
                    <table className="table-responsive">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Invoice Number</th>
                                <th>Payment Card</th>
                                <th>Renewal Date</th>
                                <th>Renewal Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !_.isEmpty(renewalData) ?
                                    renewalData.map((r, i) => {
                                        return (
                                            <tr key={`renewal-${i +1}`}>
                                                <td>{i + 1}</td>
                                                <td>{r.stripe_invoice_number}</td>
                                                <td className="text-capitalize">{r.card_brand}({r.card_last4})</td>
                                                <td>{r.renewal_date ?
                                                 moment.unix(r.renewal_date).tz('America/New_York').format('MMM DD, YYYY') : 
                                                 ""}</td>
                                                <td className="text-capitalize">{r.renewal_status}</td>
                                            </tr>
                                        )
                                    })
                                :
                                <></>
                            }
                        </tbody>
                    </table>
                </div>}
            </div>
        )
    }

    return (
        <>
            <section className="order-info-sec">
                <div className="container">
                    <div className="row payment-b2c">
                        <div className="col-12">
                            <div className="col-lg-6 col-12">
                                <div className="bred-icof justify-content-between">
                                    <BreadCrumbComponent
                                        crumbList={breadCrumbData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-lg-5">
                        <div className="col-lg-8 col-12">
                            {renderLeftPanel()}
                        </div>
                        <div className="col-lg-4 col-12 payment-right-box">
                            <RightPanelPaymentSection
                                membershipCardInfo={membershipCardInfo}
                                paymentIntentInfo={paymentIntentInfo}
                                type={'subscription'}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ViewSubscriptionReceiptSection